import moment from "moment";
import Tile from "../../Components/Tiles/Tile";
import TileContent from "../../Components/Tiles/TileContent";
import TextGroup from "../VehicleSales/TextGroup";
import TextBlock from "../../Components/Layout/TextBlock";
import { Vehicle } from "../../system/Domain";

export const LeasmanSyncStatus = ({ vehicle }: { vehicle: Vehicle }) => {
	const referenceCreated = vehicle.remarketing.leasmanContract?.dateReferenceCreated;

	return (
		<TextGroup title="Leasman Synchronisation">
			<TextBlock
				primary={
					!!referenceCreated
						? moment(referenceCreated).format("DD.MM.YYYY HH:mm")
						: "-"
				}
				secondary="Letzte erfolgreiche Synchronisation"
			/>
		</TextGroup>
	);
};

interface Props {
	vehicle: Vehicle
}

const LeasmanSyncTile = ({ vehicle }: Props) => (
	<Tile>
		<TileContent>
			<LeasmanSyncStatus vehicle={vehicle} />
		</TileContent>
	</Tile>
);

export default LeasmanSyncTile;
